// extracted by mini-css-extract-plugin
module.exports = {"link":"_2A31g","image":"_1cm1L","root":"_1y5xO"};